import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { UnionPayRemittanceScreenProps } from '@/features/bill-payment/screens/union-pay/UnionPayRemittance.screen';
import { UnionPayMoreScreenProps } from '@/features/bill-payment/screens/union-pay/UnionPayMore.screen';
import { InformationScreenProps } from '@/features/bill-payment/screens/union-pay/Information.screen';
import { ConfirmationScreenProps } from '@/features/bill-payment/screens/union-pay/Confirmation.screen';
import { PlacedScreenProps } from '@/features/bill-payment/screens/union-pay/Placed.screen';
import { TWOFAScreenProps } from '@/features/bill-payment/screens/union-pay/TWOFA.screen';
import { BillPaymentUnionPay } from '@/features/bill-payment/payment.navigator';

export enum UnionPayStackRoutes {
  UnionPayRemittance = 'UnionPayRemittance',
  UnionPayMore = 'UnionPayMore',
  Information = 'Information',
  Confirmation = 'Confirmation',
  Placed = 'Placed',
  SelectAccount = 'SelectAccount',
  AddNewAccount = 'AddNewAccount',
  AccountSelect = 'AccountSelect',
  TWOFA = 'TWOFA'
}

export interface UnionPayModalProps {
  onLayout: (event: any) => void;
}

export type UnionPayStackParamList = {
  [UnionPayStackRoutes.UnionPayRemittance]: UnionPayModalProps & UnionPayRemittanceScreenProps & BillPaymentUnionPay;
  [UnionPayStackRoutes.UnionPayMore]: UnionPayMoreScreenProps;
  [UnionPayStackRoutes.Information]: UnionPayModalProps &
    BillPaymentUnionPay &
    InformationScreenProps & {
      onBack?: (flag?: boolean) => void;
      transferPeer?: any;
      wallet?: any;
      calcFee?: any;
      onChangeView?: () => void;
      transferPeerCountFlag?: boolean;
    };
  [UnionPayStackRoutes.Confirmation]: UnionPayModalProps &
    BillPaymentUnionPay &
    ConfirmationScreenProps & {
      onBack?: (flag?: boolean) => void;
      wallet?: any;
      calcFee?: any;
      beneficiaryInformation?: any;
      onChangeView?: () => void;
    };
  [UnionPayStackRoutes.Placed]: UnionPayModalProps &
    BillPaymentUnionPay &
    PlacedScreenProps & {
      onBack?: (flag?: boolean) => void;
      wallet?: any;
      calcFee?: any;
      beneficiaryInformation?: any;
      refId?: string;
    };
  [UnionPayStackRoutes.SelectAccount]: UnionPayModalProps & {
    onBack?: (flag?: boolean) => void;
    onSelect?: (data: any) => void;
    onChangeView?: () => void;
  };
  [UnionPayStackRoutes.AddNewAccount]: UnionPayModalProps &
    BillPaymentUnionPay & {
      onBack?: (flag?: boolean) => void;
      onAccountSubmit?: (flag: boolean, data: any) => void;
      transferPeerCountFlag?: boolean;
      wallet?: any;
      calcFee?: any;
      onChangeView?: () => void;
    };
  [UnionPayStackRoutes.AccountSelect]: UnionPayModalProps & {
    onBack?: (flag?: boolean) => void;
    asset?: any;
    onSelect: (walletId: string, wallet?: any) => void;
  };
  [UnionPayStackRoutes.TWOFA]: UnionPayModalProps &
    BillPaymentUnionPay &
    TWOFAScreenProps & {
      onBack?: (flag?: boolean) => void;
      wallet?: any;
      calcFee?: any;
      beneficiaryInformation?: any;
      onChangeView?: () => void;
    };
};

export type UnionPayStackScreenProps<Screen extends keyof UnionPayStackParamList> = NativeStackScreenProps<UnionPayStackParamList, Screen>;
